import React from "react";
import { BsFire } from "react-icons/bs";
import { Timeline } from "primereact/timeline";
const HotLeadHistoryModel = ({ isOpen, isClose, selectedLeaddata }) => {
  if (!isOpen) return null;

  console.log(selectedLeaddata);

  const events = selectedLeaddata.map((item) => ({
    log: item.leadSource,
    timestamp: item.enterDate,
    notes: item.notes,
  }));
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
      <div className="bg-white rounded-[10px] shadow-xl w-[560px]   p-6 transform transition-all">
        {/* Header */}
        <div className="flex bg-slate-100 p-2 rounded-md justify-between items-center mb-6">
          <h2
            id="bulk-upload-title"
            className="text-lg font-medium text-green-700"
          >
            <div className="bg- cursor-pointer flex items-center justify-center gap-2 text-base text-[#EE6C4D] font-medium s w-full rounded-[10px] p-2">
              <BsFire className="text-xl" />
              <div>Hot Lead History</div>
            </div>
          </h2>
          <button
            onClick={isClose}
            className="text-red-600 bg-white px-2 focus:outline-none  rounded-full p-1"
            aria-label="Close modal"
          >
            <svg
              className="w-5 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Timeline */}
        <div className="max-h-72 overflow-y-auto custom-scrollbar pr-2">
          <Timeline
            className="px-2 mt-4"
            value={events}
            opposite={(item) => (
              <small className="text-gray-500 text-sm">{item?.timestamp}</small>
            )}
            content={(item) => (
              <div className="flex flex-col gap-1">
                <p className="text-base text-gray-800 font-medium">
                  {item.log}
                </p>
                <p className="text-sm text-gray-600 ">({item.notes})</p>
              </div>
            )}
            marker={() => (
              <span className="w-5 h-5 border-customGreen border-2 bg-white rounded-full block " />
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default HotLeadHistoryModel;
